module.exports = "/assets/data/126729351da77b17606ae49b005eda56-CB5.data.json";